import { environment } from '../../../../environments/environment';
import { arrayAndObjectLevelConstants } from './array-and-object-level-config';

export function setImageUrl(financierId: string) {
    let financierIds = arrayAndObjectLevelConstants.financierIds[environment.env_stage];
    let image = '';
    if (financierId) {
        switch (financierId) {
            case financierIds.tmf:
                image = "assets/fni-assets/images/Tata_Capital.png";
                break;
            case financierIds.chola:
                image = "assets/fni-assets/images/chola.svg";
                break;
            case financierIds.sbi:
                image = "assets/fni-assets/images/sbi.svg";
                break;
            case financierIds.hdfc:
                image = "assets/fni-assets/images/HDFC-logo.svg";
                break;
            case financierIds.sundaram:
                image = "assets/fni-assets/images/sundaram.svg";
                break;
            case financierIds.hdbfs:
                image = "assets/fni-assets/images/HDBFS-logo.svg";
                break;
            case financierIds.yesBank:
                image = "assets/fni-assets/images/yes-bank-logo.svg";
                break;
            case financierIds.auFinance:
                image = "assets/fni-assets/images/AU-Logo_1.svg";
                break;
            case financierIds.equitas:
                image = "assets/fni-assets/images/Equitas-logo-02.svg";
                break;
            case financierIds.idfcFinance:
                image = "assets/fni-assets/images/IDFC-logo-website.svg";
                break;
            case financierIds.kotak:
                    image = "assets/fni-assets/images/Kotak-Mahindra-Bank.svg";
                    break;
            default:
                break;
        }
    }
    return image;
}

export function getFinancierName(financierId: string) {
    let financierIds = arrayAndObjectLevelConstants.financierIds[environment.env_stage];
    let financerName = '';
    if (financierId) {
        switch (financierId) {
            case financierIds.tmf:
                financerName = "Tata Capital";
                break;
            case financierIds.chola:
                financerName = "CHOLA";
                break;
            case financierIds.sbi:
                financerName = "SBI";
                break;
            case financierIds.hdfc:
                financerName = "HDFC";
                break;
            case financierIds.sundaram:
                financerName = "SUNDARAM";
                break;
            case financierIds.hdbfs:
                financerName = "HDBFS";
                break;
            case financierIds.yesBank:
                financerName = "YES BANK";
                break;
            case financierIds.auFinance:
                financerName = "AU FINANCE";
                break;
            case financierIds.equitas:
                financerName = "EQUITAS FINANCE ";
                break;
            case financierIds.idfcFinance:
                    financerName = "IDFC FINANCE ";
                    break;
            case financierIds.kotak:
                        financerName = "KOTAK BANK";
                        break;
            default:
                break;
        }
    }
    return financerName;
}